import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useUserContext } from '../../Contexts/User';

const ACCEPT_TERMS_PATH = '/accept-terms';

/**
 * Redirects users who must accept their organisation's terms of use to the full-screen
 * accept-terms page. The backend independently hard-blocks all other endpoints, so this
 * is UX routing, not the security boundary.
 */
export function TermsOfUseGate() {
  const { user } = useUserContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!user) return;
    if (user.termsAcceptanceRequired === true && pathname !== ACCEPT_TERMS_PATH) {
      navigate(ACCEPT_TERMS_PATH, { replace: true });
    }
  }, [user, pathname, navigate]);

  return null;
}
